export const DAO_CODE = 'PRODUCTION_CATEGORIES' + '_DAO';
